import { TDate } from '@monorepo/types';
import moment from 'moment';
import { TNptActions } from './npt.actions';
import { NPT_REASONS_UPLOAD_DEFAULT_PAGINATION_OPTION, TNptActionTypes, TNptState } from './npt.models';

export const initialState: TNptState = {
  nptLinesDetails: null,
  nptWorkstationsGroups: null,
  nptReasons: [],
  workstationsNpts: [],
  selectedDate: moment().format('YYYY-MM-DD') as TDate,
  nptReasonsList: null,
  nptReasonsListPaginationOption: NPT_REASONS_UPLOAD_DEFAULT_PAGINATION_OPTION,
};

export function nptReducer(state = initialState, action: TNptActions): TNptState {
  switch (action.type) {
    case TNptActionTypes.GetNptLinesDetails:
      return {
        ...state,
        nptLinesDetails: null,
      };
    case TNptActionTypes.GetNptLinesDetailsSuccess:
      return {
        ...state,
        nptLinesDetails: action.nptLinesDetails,
      };
    case TNptActionTypes.GetNptWorkstationsDetails:
      return {
        ...state,
        nptWorkstationsGroups: null,
      };
    case TNptActionTypes.GetNptWorkstationsDetailsSuccess:
      return {
        ...state,
        nptWorkstationsGroups: action.nptWorkstationGroups,
      };
    case TNptActionTypes.SetNptReasons:
      return {
        ...state,
        nptReasons: action.nptReasons,
      };
    case TNptActionTypes.NptSetSelectedDate:
      return {
        ...state,
        selectedDate: action.selectedDate,
      };
    case TNptActionTypes.GetWorkstationsNptsSuccess:
      return {
        ...state,
        workstationsNpts: action.workstationNpts,
      };
    case TNptActionTypes.FetchNptReasonsListSuccess:
      return {
        ...state,
        nptReasonsList: action.payload,
      };
    case TNptActionTypes.SetReasonsListPaginationOption:
      return {
        ...state,
        nptReasonsListPaginationOption: action.payload,
      };
    default:
      return state;
  }
}
